import winstonLogger from '@bt-react/libs/winstonLogger'

const logger = winstonLogger('player-page', 'error', process.env.LOCAL_ENV)

export default logger
